//  NODE MODULES
import firebase from 'firebase';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCjGX2UaL4P4OB4wJySIe0rMC8hWXLD2PM",
    authDomain: "karaoke-project6.firebaseapp.com",
    databaseURL: "https://karaoke-project6.firebaseio.com",
    projectId: "karaoke-project6",
    storageBucket: "karaoke-project6.appspot.com",
    messagingSenderId: "608841147627"
  };
  firebase.initializeApp(config);


export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js